import type {Router} from 'vue-router';
import {configure} from 'vue-gtag';

export function initGtag(router: Router) {
    configure({
        tagId: 'G-NWFRX8HJBK',
        initMode: 'manual',
        config: {
            send_page_view: true
        },
        pageTracker: {
            router,
            useRouteFullPath: true
        }
    });
}